<p-toast key="global" position="bottom-right" />

@if(!useAuthenticatedLayout) {
  <main class="app-main">
      <router-outlet></router-outlet>
  </main>
}
@else {
  <app-authenticated-wrapper></app-authenticated-wrapper>
}
